var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "n-page",
    { attrs: { padding: "" } },
    [_c("club-member-header", { attrs: { member: _vm.member } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }